import { AccountMovement, Direction, invertDirection } from "../db/AccountMovement";

export interface Movement {
  side: Direction;
  amount: number;
  primary: boolean;
  meta: {
    id: string;
    source: AccountMovement;
    date: Date;
  };
}

export class AccountSum {
  public primary = false;
  public total = 0;
  public history: Movement[] = [];

  constructor(readonly accountNumber: number) {}
  public add(m: Movement) {
    this.history.push(m);
    if (m.primary) {
      this.primary = true;
    }
    this.total += m.amount * (m.side === Direction.Haben ? -1 : 1);
  }
  public finish() {
    this.total = Math.round(this.total * 10000) / 10000;
  }
}

export default class AccountAnalyze {
  public static async process(db: PouchDB.Database) {
    const accounts: { [accountNumber: number]: AccountSum } = {};

    const data = (await db.allDocs<AccountMovement>({
      startkey: "am:",
      endkey: "am:\ufff0",
      include_docs: true
    })).rows.map(m => m.doc!);
    for (const row of data) {
      if (!accounts[row.sourceAccountNumber]) {
        accounts[row.sourceAccountNumber] = new AccountSum(row.sourceAccountNumber);
      }
      if (!accounts[row.contraAccountNumber]) {
        accounts[row.contraAccountNumber] = new AccountSum(row.contraAccountNumber);
      }
      const source = accounts[row.sourceAccountNumber];
      const contra = accounts[row.contraAccountNumber];
      source.add({
        side: row.direction,
        amount: row.amount,
        primary: true,
        meta: {
          id: row._id,
          source: row,
          date: row.date
        }
      });
      contra.add({
        side: invertDirection(row.direction),
        amount: row.amount,
        primary: false,
        meta: {
          id: row._id,
          source: row,
          date: row.date
        }
      });
    }

    const result = Object.values(accounts);
    result.sort((a, b) => {
      if (a.primary === b.primary) {
        return a.accountNumber - b.accountNumber;
      }
      return a.primary ? -1 : 1;
    });
    return result;
  }

  public static async fetch(db: PouchDB.Database, accountNo: number) {
    console.log("fetchAccountData", accountNo);
    const data = (await db.allDocs<AccountMovement>({
      startkey: "am:",
      endkey: "am:\ufff0",
      include_docs: true
    })).rows
      .map(m => m.doc!)
      .filter(m => m.sourceAccountNumber === accountNo || m.contraAccountNumber === accountNo)
      .map(row =>
        row.sourceAccountNumber === accountNo
          ? {
              side: row.direction,
              amount: row.amount,
              primary: true,
              meta: {
                id: row._id,
                source: row,
                date: row.date
              }
            }
          : {
              side: invertDirection(row.direction),
              amount: row.amount,
              primary: false,
              meta: {
                id: row._id,
                source: row,
                date: row.date
              }
            }
      );
    console.log("filtered result", data.length);
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/AccountAnalyze.ts